export default __webpack_public_path__ + "static/media/speakers__kate-oneill.ba80dfd7.jpg";